import { css, jsx } from '@emotion/core';
import { Icon, Modal, notification } from 'antd';
import Router from 'next/router';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { resetForm } from '@/src/register/redux/registerAccountReducer';
import formatPayload from '@/src/register/utils';
import Button from '@/src/shared/components/Button';
import RequiredFields from '@/src/shared/components/RequiredFields';
import { colors } from '@/styles';
import request from '@/utils/axios';

const { confirm } = Modal;
const styles = {
  buttonContainer: css`
    display: flex;
    flex-direction: row;
    margin: 0 auto;
    justify-content: space-between;
    width: 100%;
    max-width: 56.9rem;
  `,
  requiredInfo: css`
    display: flex;
    flex-direction: row;
    margin: 2.4rem auto 0;
    width: 100%;
    max-width: 56.9rem;
  `,
  requiredInfoText: css`
    margin: 0 0 0 4px;
  `,
  requiredInfoSymbol: css`
    font-weight: 900;
    color: ${colors.primaryBlue};
    margin: 0;
  `,
  closeButton: css`
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 1.2rem;
    font-weight: 900;
    visibility: hidden;
  `,
  closeButtonText: css`
    margin-bottom: 0;
    font-size: 1.2rem;
    font-weight: 900;
    margin-left: 0.8rem;
  `,
};

const FormButtons = props => {
  const { form, step, maxSteps, changeCurrentStep } = props;
  const dispatch = useDispatch();
  const { register } = useSelector(state => state);
  const handleExit = () => {
    const touched = form.isFieldsTouched();

    if (!touched) {
      Router.back();
      return;
    }
    confirm({
      title: `Are you sure want to exit the registration?`,
      keyboard: true,
      okText: 'OK',
      cancelText: 'Cancel',
      // cancelButtonProps: { className: style['button--gray'] },
      // okButtonProps: { className: style['button--modal'] },
      onOk: Router.back,
    });
  };
  const completeRegistration = async () => {
    await form.validateFields(async (err, values) => {
      if (err) throw err;
      const formValues = {
        ...register,
        ...values,
      };
      const payload = formatPayload(formValues);
      try {
        const response = await request({
          method: 'POST',
          url: 'profile/submitregistration',
          data: payload,
        });
        const { data } = response;
        if (data.Success && data.Success === 'true') {
          notification.success({
            message: 'Success',
            description: data.Message,
          });

          // gtm custom event trigger
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event: 'sign_up' });

          await Router.push(
            '/register/submission-confirmation',
            '/register/submission-confirmation'
          );
          dispatch(resetForm());
        }
        if (data.Success && data.Success === 'false') {
          notification.error({
            message: 'Error',
            description: data.Errors.ErrorList.map(e => e.ErrorMessage).join(', '),
          });
        }
      } catch (errors) {
        notification.error({
          message: 'Error',
          description: 'There are errors submitting the registration.',
        });
        throw errors;
      }
    });
  };

  const prevBtnClick = async () => {
    changeCurrentStep(step - 1);
    scrollToFormTop();
  };

  const nextBtnClick = async () => {
    await form.validateFieldsAndScroll(async err => {
      if (err) throw err;
      changeCurrentStep(step + 1);
      scrollToFormTop();
    });
  };

  const scrollToFormTop = () => {
    document.getElementById('registration-form').scrollIntoView();
  };
  const renderLeftButton = () => {
    if (step === 0) {
      return (
        <a onClick={handleExit} css={styles.closeButton}>
          <Icon type="close" />
          <p css={styles.closeButtonText}>Exit Registration</p>
        </a>
      );
    }

    return (
      <Button onClick={prevBtnClick} theme="gray" size="small">
        Previous
      </Button>
    );
  };

  const renderRightButton = () => {
    if (step === maxSteps) {
      return (
        <Button size="small" onClick={completeRegistration}>
          Complete Registration
        </Button>
      );
    }
    return (
      <Button onClick={nextBtnClick} size="small" theme="default">
        Next
      </Button>
    );
  };

  return (
    <>
      <div css={styles.buttonContainer}>
        {renderLeftButton()}
        {renderRightButton()}
      </div>
      <div css={styles.requiredInfo}>
        <RequiredFields />
      </div>
    </>
  );
};

export default FormButtons;
